var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0164 1.48697C6.21464 1.48697 1.51147 6.19013 1.51147 11.9918C1.51147 17.7936 6.21464 22.4967 12.0164 22.4967C17.8181 22.4967 22.5212 17.7936 22.5212 11.9918C22.5212 6.19013 17.8181 1.48697 12.0164 1.48697ZM18.3434 9.05449L11.0745 16.4809C11.0497 16.5181 11.0221 16.5536 10.9896 16.5865C10.7047 16.8758 10.2429 16.8758 9.95776 16.5865L6.34715 12.9203C6.06246 12.6309 6.06246 12.162 6.34715 11.873C6.63203 11.5836 7.09388 11.5836 7.37878 11.873L10.4628 15.0041L17.3115 8.0068C17.5966 7.71744 18.0583 7.71744 18.3434 8.0068C18.6281 8.29617 18.6281 8.76507 18.3434 9.05449Z",
    fill: "#7FC112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8311e16b4becedff1db656fb2fc4e744.svg";
export { ForwardRef as ReactComponent };